/**
 * Collapses a paragraph or large group of words down to a specified
 * number of lines
 */
define(['jquery'], function ($) {
   "use strict";

   return function (jElement, lines, options) {
      var m_options = $.extend({
            expandText: '&hellip;more',
            collapseText: '< less',
            expandURL: ''
         }, options),
         m_iBRPatt = /(<br\/?>){2}/,
         m_iWidth = jElement.width(),
         m_sOrigText = jElement.html().replace(/\s+/g, ' '),
         m_aWords = m_sOrigText.split(' '),
         m_elCSS = "padding:0; margin:0; border:none; font:inherit;",
         m_elTable = $('<div style="' + m_elCSS + 'width:auto;zoom:1;position:absolute;"><div style="' + m_elCSS + '"><div class="expandAnchor" style="' + m_elCSS + '"> <a href="javascript: void(0)">' + m_options.expandText + '</a></div></div></div>'),
         m_elTemp = m_elTable.find(".expandAnchor"),
         m_iCurrentLine = 1,
         m_sPrevLines = '',
         m_sText = '',
         m_sLastText = '',
         m_bOnHidden = false,
         m_iTailWidth,
         m_iTargetWidth,
         m_jCollapseSpan,
         m_jExpandAnchor,
         self = this;

      jElement.html(m_elTable);

      // Get the new height and width
      m_iTailWidth = m_elTemp.width() + 10;
      m_iTargetWidth = m_iWidth - m_iTailWidth;

      //console.log("tail width: " + m_iTailWidth);
      //console.log("target width: " + m_iTargetWidth);

      $.each(m_aWords, function (i, strWord) {
         var bNewline = false;
         if (m_iBRPatt.test(strWord)) {
            bNewline = true;
         }
         m_sText += strWord + ' ';
         m_elTemp.html(m_sText);

         if (!m_bOnHidden) {
            // If we haven't exceeded the max number of lines
            if (m_iCurrentLine < lines) {

               // If the line has wrapped
               if ((m_elTemp.width() + 10) >= m_iWidth || bNewline) {
                  if ((m_elTemp.width() + 10) >= m_iWidth) {
                     m_iCurrentLine++;
                  }
                  m_sPrevLines += m_sLastText;
                  m_sLastText = '';
                  m_sText = m_aWords[i] + ' ';
                  m_elTemp.html(m_sText);
                  if (bNewline) {
                     m_iCurrentLine += 2;
                  }
                  // If the line has not wrapped
               } else {
                  m_sLastText = m_sText;
               }

               // If we HAVE exceeded the max number of lines
               // and the line has wrapped
            }

            //var m_elTempWidth = m_elTemp.width();

            if ((m_iCurrentLine >= lines) && (m_elTemp.width() + 10 + m_sLastText.length) >= m_iTargetWidth) {
               //console.log("current line: " + m_iCurrentLine + " current width: " + m_elTemp.width() + 10);
               m_sLastText = m_sText;
               m_sText = '';
               m_bOnHidden = true;

               // If the line has not wrapped
            } else {
               m_sLastText = m_sText;
            }

            //console.log(m_sLastText)
         }
      });

      self.expand = function () {
         var bContinue;

         if (m_options.onBeforeExpand) {
            bContinue = m_options.onBeforeExpand(m_jCollapseSpan);
         } else {
            bContinue = true;
         }

         if (bContinue) {
            // Hide
            m_jExpandAnchor.toggle();
            m_jCollapseSpan.toggle();

            // Fade out
            m_jCollapseSpan.css({
               opacity: 0
            }).animate({
               opacity: 1
            });

            if (m_options.onExpand) {
               m_options.onExpand(m_jCollapseSpan);
            }
         }

         // Stop event propagation if false...
         return bContinue;
      };

      self.collapse = function () {
         var bContinue;

         if (m_options.onBeforeCollapse) {
            bContinue = m_options.onBeforeCollapse(m_jCollapseSpan);
         } else {
            bContinue = true;
         }

         if (bContinue) {
            // Fade out
            m_jCollapseSpan.animate({
               opacity: 0
            }, function () {
               // Hide
               m_jExpandAnchor.toggle();
               m_jCollapseSpan.toggle();

               if (m_options.onCollapse) {
                  m_options.onCollapse(m_jCollapseSpan);
               }
            });
         }

         // Stop event propagation if false...
         return bContinue;
      };

      function createAnchor() {
         var jCollapseAnchor, jTempSpan, strTitleText;

         jTempSpan = $('<span />');
         jTempSpan.html(m_sText);
         strTitleText = jTempSpan.text();

         jElement.html(m_sPrevLines + m_sLastText);

         m_jCollapseSpan = $('<span style="display: none" />');
         m_jCollapseSpan.html(m_sText);

         //Check if this is a URL in the option to direct to instead of expanding
         m_jExpandAnchor = $('<a href="javascript: void(0)" />');
         if (m_options.expandURL) {
            m_jExpandAnchor.attr('href', m_options.expandURL);
         } else {
            m_jExpandAnchor.click(self.expand);
         }

         m_jExpandAnchor.attr('title', strTitleText);
         m_jExpandAnchor.html(m_options.expandText);
         m_jExpandAnchor.appendTo(jElement);

         jCollapseAnchor = $('<a href="javascript: void(0)" />');
         jCollapseAnchor.html(m_options.collapseText);
         jCollapseAnchor.appendTo(m_jCollapseSpan);
         jCollapseAnchor.click(self.collapse);
         m_jCollapseSpan.insertAfter(jElement);

         if (m_options.startExpanded) {
            self.expand();
         }

         if (m_options.expandCallback) {
            m_jExpandAnchor.click(m_options.expandCallback);
         }

         if (m_options.collapseCallback) {
            jCollapseAnchor.click(m_options.collapseCallback);
         }
      }

      if (m_bOnHidden) {
         createAnchor();
      } else {
         jElement.html(m_sOrigText);
      }
   };
});
